import { Component, OnInit } from '@angular/core';

// TODO: to be implemented
@Component({
  selector: 'features-rights',
  templateUrl: './featuresAndRights.component.html',
  standalone: false
})
export class FeaturesAndRightsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
